export const getRarityColor = (rarity) => {
  if (!rarity) return '#000';
  
  switch(rarity.toLowerCase()) {
    case 'common': return '#9e9e9e';
    case 'uncommon': return '#4caf50';
    case 'rare': return '#2196f3';
    case 'epic': return '#9c27b0';
    case 'legendary': return '#ff9800';
    default: return '#000';
  }
};

export const getRarityMultiplier = (rarity) => {
  if (!rarity) return 1;
  
  switch(rarity.toLowerCase()) {
    case 'common': return 1;
    case 'uncommon': return 2;
    case 'rare': return 4;
    case 'epic': return 8;
    case 'legendary': return 16;
    default: return 1;
  }
};
